export default "__VITE_ASSET__07891454__"